// tslint:disable: max-line-length
import { checkStatus, parseJSON } from './utils';

const config = window.config;

const generateHeaders = (locale, authorization) => ({
  Accept: 'application/vnd.novus+json; version=1',
  'Content-Type': 'application/json',
  'Accept-Language': locale,
  Authorization: authorization
});

export const getUsers = (locale, authorization, page, limit) =>
  fetch(
    `${config.REACT_APP_BASE_URL}/api/user/directlogin/member?page=${page +
      1}&limit=${limit}`,
    {
      method: 'GET',
      headers: generateHeaders(locale, authorization)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const updateUser = (locale, authorization, user) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/directlogin/member/${user.id}`, {
    method: 'PUT',
    headers: generateHeaders(locale, authorization),
    body: JSON.stringify(user)
  })
    .then(checkStatus)
    .then(parseJSON);

export const searchUsers = (locale, authorization, page, limit, search) =>
  fetch(
    `${
      config.REACT_APP_BASE_URL
    }/api/user/directlogin/member/search?page=${page + 1}&limit=${limit}`,
    {
      method: 'POST',
      headers: generateHeaders(locale, authorization),
      body: JSON.stringify(search)
    }
  )
    .then(checkStatus)
    .then(parseJSON);

export const getAvailablePolicies = (locale, authorization) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/policy`, {
    method: 'GET',
    headers: generateHeaders(locale, authorization)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getUserPolicies = (locale, authorization, id) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/policy/user/${id}`, {
    method: 'GET',
    headers: generateHeaders(locale, authorization)
  })
    .then(checkStatus)
    .then(parseJSON);

export const getCountriesDropdown = (locale, authorization) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/country`, {
    method: 'GET',
    headers: generateHeaders(locale, authorization)
  })
    .then(checkStatus)
    .then(parseJSON);

export const setUserPolicies = (locale, authorization, userId, policyIds) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/policy/user/${userId}`, {
    method: 'PUT',
    headers: generateHeaders(locale, authorization),
    body: JSON.stringify({
      policy_ids: policyIds
    })
  })
    .then(checkStatus)
    .then(parseJSON);

export const createUser = (locale, authorization, data) =>
  fetch(`${config.REACT_APP_BASE_URL}/api/user/directlogin/member`, {
    method: 'POST',
    headers: generateHeaders(locale, authorization),
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(parseJSON);



// WEBPACK FOOTER //
// ./src/api/users.js